import { useRef, Fragment, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { createMultipleRef, getValueInputRef } from '../helpers'
import { inject, observer } from 'mobx-react';
import UserService from "../services/UserService";
import { Transition, Menu } from '@headlessui/react'
import { Modal, InputPassword, FormLoading, ModalAlert, Input, Button } from '../components'
import Breadcrumbs from './Breadcrumbs';
import {
  LogoutIcon,
  MenuIcon,
  UploadIcon
} from '@heroicons/react/outline'
import { KeyIcon } from '@heroicons/react/solid';
import { isEmpty } from 'lodash'
import { Image } from 'antd';
import { BASE_URL } from '../AppConfig'

const Header = inject("authenStore", "commonStore")(observer((props) => {
  const navigate = useNavigate()
  let authenStore = props.authenStore
  let { setCommonValue, getAccountAuth } = authenStore
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  let { onOpen, onExpand } = props // ACTION
  const [loading, setLoading] = useState(false)
  const [shakeIsWrong, setShakeIsWrong]: any = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showSignModal, setShowSignModal] = useState(false)
  const [validation, setValidation]: any = useState({})
  const [loadingUploadSign, setLoadingUploadDocSign]: any = useState({ visible: false, tip: "" })
  const [dataForm, setDataForm]: any = useState({
    "id": "",
    "employee_code": "",
    "username": "",
    "password": "",
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone_no": "",
    "position": "",
    "user_status": "Y",
    "user_group_id": "",
    "role_level": "",
    "signature_url": ""
  })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: "",
      data: {}
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const inputRef: any = useRef([]);
  const inputUploadRef: any = useRef(null);
  createMultipleRef(inputRef, 2)

  const onSave = () => {
    let formData = getValueInputRef(inputRef)
    let validation: any = {}
    if (formData.passwordold === "") {
      validation.passwordold = { isError: true, message: "โปรดระบุ" }
    }
    if (formData.passwordnew === "") {
      validation.passwordnew = { isError: true, message: "โปรดระบุ" }
    }
    if (formData.passwordconfirm === "") {
      validation.passwordconfirm = { isError: true, message: "โปรดระบุ" }
    }
    else if (formData.passwordconfirm !== formData.passwordnew) {
      validation.passwordconfirm = { isError: true, message: "รหัสผ่านไม่ตรงกัน" }
    }

    if (isEmpty(validation)) {
      setValidation({})
      setOptionAlert({
        ...optionAlert,
        type: "confirm",
        title: "ยืนยัน",
        show: true,
        description: {
          visible: true,
          type: "text",
          content: "คุณแน่ใจที่จะบันทึกข้อมูล ?",
          contentLists: []
        }
      })
    }
    else {
      setValidation(validation)
      setShakeIsWrong(true)
      setTimeout(() => setShakeIsWrong(false), 100);
    }
  }

  const updatePassword = () => {
    let formData = getValueInputRef(inputRef)
    UserService.changePessword(auth, {
      current_password: formData.passwordold,
      new_password: formData.passwordnew,
      confirm_new_password: formData.passwordconfirm,
    })
      .then((res: any) => {
        let { code, message, sys_message } = res?.data
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: "",
              data: {}
            },
            title: "บันทึกข้อมูลสำเร็จ",
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          setShowModal(false)
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: "",
              data: {}
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: "",
            data: {}
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const getUserProfile = () => {
    setLoadingUploadDocSign({ visible: true, tip: "กำลังโหลด..." })
    UserService.getUsers(auth, auth.action_user_id)
      .then((res: any) => {
        let { code, message, sys_message } = res
        if (code === 200) {
          let result = res?.result || []
          if (result.length > 0) {
            let profile = result[0]
            setDataForm(profile)
          }
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: "",
              data: {}
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoadingUploadDocSign({ visible: false, tip: "กำลังโหลด..." })
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: "",
            data: {}
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
        setLoadingUploadDocSign({ visible: false, tip: "กำลังโหลด..." })
      })
  }

  const handleFileSignChange = (e) => {
    if (!e.target.files) return;

    // VALIDATE FILE UPLOAD
    let isError = false
    const fileLists = Array.from(e.target?.files)

    // let { service_id, sub_id } = uploadInfo
    //qwe
    if (!isError) {
      setLoadingUploadDocSign({ visible: true, tip: "กำลังอัปโหลด..." })

      const data = new FormData();
      fileLists.forEach((file: any, i) => {
        data.append('files', file, file.name);
      });
      fetch(`${BASE_URL}/user/upload_sign?user_id=${dataForm.id}&action_user_id=${auth.action_user_id}`, {
        method: 'PUT',
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          let { code, message, sys_message } = data
          if (code === 200) {
            getUserProfile()
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: "",
                data: {}
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })

          }
          setLoadingUploadDocSign({ visible: false, tip: "กำลังอัปโหลด..." })
        })
        .catch((err) => {
          setLoadingUploadDocSign({ visible: false, tip: "กำลังอัปโหลด..." })
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: "",
              data: {}
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
        })
    }
  }
  return (
    <>
      <div className="flex flex-col sticky top-0 z-10 h-16 flex-shrink-0 bg-white shadow">
        <div className="flex flex-1 justify-between px-4">
          <div className="flex flex-1">
            <div className="relative inset-y-0 left-0 flex items-center">
              <MenuIcon
                className="h-6 w-6 cursor-pointer text-blue-700 hover:text-blue-400"
                onClick={() => {
                  onOpen(true)
                  onExpand()
                }}
              />
            </div>
          </div>
          <div className="ml-4 flex items-center md:ml-6">
            {/* <button
              type="button"
              className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">View notifications</span>
              <BellIcon className="h-6 w-6" aria-hidden="true" />
            </button> */}

            {/* Profile dropdown */}
            <Menu as="div" className="relative ml-3 z-50">
              <div>
                <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm">
                  <span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
                    <svg className="h-full w-full text-primary-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </span>
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 mt-2 w-64 origin-top-right rounded-md border bg-white dark:bg-gray-800 py-1 shadow-lg">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <span className="flex h-10 w-10 overflow-hidden rounded-full bg-gray-100 shadow-md">
                      <svg className="h-full w-full text-primary-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </span>
                    <div className="flex-1">
                      <div className="flex items-center">
                        <h3 className="text-sm font-medium text dark:text-white">{getAccountAuth?.user_fullname}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="w-full border-t border-gray-300" />
                  <div className='mt-2'>
                    <Menu.Item>
                      <a
                        type='button'
                        className='cursor-pointer flex flex-row px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-300 dark:hover:text-gray-600'
                        onClick={() => {
                          getUserProfile()
                          setShowSignModal(true)
                        }}
                      >
                        <DocumentEditIcon className="w-5 h-5 mr-2 text-gray-700" />กำหนดลายเซ็น
                      </a>
                    </Menu.Item>


                    <Menu.Item>
                      <a
                        type='button'
                        className='cursor-pointer flex flex-row px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-300 dark:hover:text-gray-600'
                        onClick={() => setShowModal(true)}
                      >
                        <KeyIcon className='w-5 h-5 mr-2' />เปลี่ยนรหัสผ่าน
                      </a>
                    </Menu.Item>

                    <Menu.Item>
                      <a
                        className='cursor-pointer flex flex-row px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-300 dark:hover:text-gray-600'
                        onClick={() => {
                          navigate("/")
                          setCommonValue({ accountAuth: {} })
                        }}
                      >
                        <LogoutIcon className='w-5 h-5 mr-2' />ออกจากระบบ
                      </a>
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
        <div className="flex flex-row border-t border-gray-200 p-1 bg-white">
          <Breadcrumbs />
        </div>
      </div>

      <Modal
        title={{ text: "เปลี่ยนรหัสผ่าน" }}
        open={showModal}
        maskClosable={true}
        contentPadding="p-0"
        shake={shakeIsWrong}
        onClosed={() => !loading && setShowModal(false)}
        onOk={() => !loading && onSave()}
      >
        <FormLoading loading={loading} tip="กำลังบันทึก...">
          <div className="flex flex-col space-y-2" style={{ padding: 20 }}>
            <InputPassword
              id="passwordold"
              label="รหัสผ่านปัจจุบัน"
              placeholder="รหัสผ่านปัจจุบัน"
              hiddenIcon={true}
              required={true}
              validate={validation?.passwordold}
              onRef={(ref) => inputRef.current[0] = ref}
            />

            <InputPassword
              id="passwordnew"
              label="รหัสผ่านใหม่"
              placeholder="รหัสผ่านใหม่"
              hiddenIcon={true}
              required={true}
              validate={validation?.passwordnew}
              onRef={(ref) => inputRef.current[1] = ref}
            />

            <InputPassword
              id="passwordconfirm"
              label="ยืนยันรหัสผ่าน"
              placeholder="ยืนยันรหัสผ่าน"
              hiddenIcon={true}
              required={true}
              validate={validation?.passwordconfirm}
              onRef={(ref) => inputRef.current[2] = ref}
            />
          </div>
        </FormLoading>
      </Modal>

      <Modal
        title={{ text: "ผู้ใช้งาน" }}
        open={showSignModal}
        maskClosable={true}
        // shake={shakeIsWrong}
        onClosed={() => !loadingUploadSign.visible && setShowSignModal(false)}
        onOk={() => {
          // !loading && onSave()
        }}
        footer={<Button
          text="ปิด"
          type="white"
          width="w-20"
          onClick={() => setShowSignModal(false)}
        />}
      >
        <FormLoading loading={loadingUploadSign.visible} tip={loadingUploadSign.tip}>
          <div className='md:space-y-2'>
            <div className="flex md:flex-row sm:flex-col xs:flex-col md:space-x-4">
              <div className='flex-1'>
                <Input
                  id="group_name"
                  label="กลุ่มผู้ใช้งาน"
                  disabled={true}
                  defaultValue={dataForm.group_name}
                />
              </div>

              <div className='flex-1'>
                <Input
                  id="status_name"
                  label="สถานะ"
                  disabled={true}
                  defaultValue={dataForm.status_name}
                />
              </div>
            </div>

            <div className="flex md:flex-row sm:flex-col xs:flex-col md:space-x-4">
              <div className='flex-1'>
                <Input
                  id="first_name"
                  label="ชื่อ"
                  disabled={true}
                  defaultValue={dataForm.first_name}
                />
              </div>

              <div className='flex-1'>
                <Input
                  id="last_name"
                  label="นามสกุล"
                  disabled={true}
                  defaultValue={dataForm.last_name}
                />
              </div>
            </div>

            <div className="flex md:flex-row sm:flex-col xs:flex-col md:space-x-4">
              <div className='flex-1'>
                <Input
                  id="employee_code"
                  label="รหัสพนักงาน"
                  disabled={true}
                  defaultValue={dataForm.employee_code}
                />
              </div>

              <div className='flex-1'>
                <Input
                  id="position"
                  label="ตำแหน่ง"
                  disabled={true}
                  defaultValue={dataForm.position}
                />
              </div>
            </div>

            <div className="flex md:flex-row sm:flex-col xs:flex-col md:space-x-4">
              <div className='flex-1'>
                <Input
                  id="username"
                  label="ชื่อล็อคอิน"
                  disabled={true}
                  defaultValue={dataForm.username}
                />
              </div>

              <div className='flex-1'>
                <Input
                  id="phone_no"
                  label="เบอร์โทร"
                  disabled={true}
                  defaultValue={dataForm.phone_no}
                />

              </div>
            </div>

            <div className="flex md:flex-row sm:flex-col xs:flex-col md:space-x-4">
              <div className='flex-1'>
                <Input
                  id="email"
                  label="อีเมล"
                  disabled={true}
                  defaultValue={dataForm.email}
                />
              </div>

              <div className='flex-1'>
                <Input
                  id="role_level_name"
                  label="ระดับผู้ใช้งาน"
                  disabled={true}
                  defaultValue={dataForm.role_level_name}
                />
              </div>
            </div>

            <div className="w-56 shrink-0 rounded-md">
              <div className="text-sm font-medium text-gray-700 mb-2">
                ลายเซ็น
              </div>

              {/* <FormLoading loading={loadingUploadSign} tip="กำลังอัปโหลด"> */}
              <div className="w-full h-32 overflow-hidden rounded border bg-white flex items-center justify-center">
                <div className="w-[200px] h-[128px] overflow-hidden rounded-lg">
                  {
                    !isEmpty(dataForm.signature_url) && <Image
                      preview={false}
                      src={dataForm.signature_url}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  }
                </div>
              </div>
              {/* </FormLoading> */}

              <input
                className="hidden"
                type="file"
                ref={inputUploadRef}
                onChange={handleFileSignChange}
              />

              <Button
                text="อัปโหลด"
                icon={<UploadIcon />}
                size="sm"
                type="white"
                width="w-full"
                iconPosition="start"
                className="mt-2"
                onClick={() => inputUploadRef.current.click()}
              />
            </div>

          </div>
        </FormLoading>
      </Modal>


      <ModalAlert
        {...optionAlert}
        onOk={() => {
          let { type } = optionAlert
          if (type === "confirm") updatePassword()
          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => setOptionAlert({ ...optionAlert, show: false })}
      />
    </>
  )
}))

export default Header;


const DocumentEditIcon = ({ className = "w-6 h-6 text-black" }) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      {/* document */}
      <rect x="3" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />

      {/* lines */}
      <line x1="6" y1="7" x2="14" y2="7" stroke="currentColor" strokeWidth="2" />
      <line x1="6" y1="11" x2="12" y2="11" stroke="currentColor" strokeWidth="2" />
      <line x1="6" y1="15" x2="10" y2="15" stroke="currentColor" strokeWidth="2" />

      {/* pencil */}
      <path d="M14 14L20 8L22 10L16 16L14 16Z" />
    </svg>
  );
};
